export const locale = {
  lang: "it",
  data: {
    EDIT_INTERVIEW: "Modifica colloquio",
    ALERT: {
      ERROR_DRAG_CANDIDATE_ONLY_CREATOR: "Puoi spostare solo i candidati che hai reso idonei.",
    },
  },
};
